import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AccialVoucherSyncResponse } from 'src/app/core/interfaces/accial-voucher-sync';
import { ServiceMessages } from 'src/app/core/messages/service-messages.enum';
import { AccialService } from 'src/app/core/services/accial.service';
import { SnackBarService } from 'src/app/core/services/snackBar.service';

@Component({
  selector: 'app-cargo-cash-receipts',
  templateUrl: './cargo-cash-receipts.component.html',
  styleUrls: ['./cargo-cash-receipts.component.scss']
})
export class CargoCashReceiptsComponent implements OnInit, OnDestroy {
  form: FormGroup;
  isLoading = false;
  private _destroy$ = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<CargoCashReceiptsComponent>,
    private spinner: NgxSpinnerService,
    private snackBarService: SnackBarService,
    private accialService: AccialService,
  ) { }

  ngOnInit() {
    this.initForm();
  }

  ngOnDestroy() {
    this.spinner.hide();
    this._destroy$.next();
    this._destroy$.complete();
  }

  private initForm() {
    this.form = new FormGroup({
      file: new FormControl('', Validators.required),
    });
  }

  /**
   * Mientras la carga está en curso el diálogo no se puede cerrar, para que la
   * subida no se aborte a mitad de camino y el archivo quede sin procesar.
   */
  private setLoading(isLoading: boolean) {
    this.isLoading = isLoading;
    this.dialogRef.disableClose = isLoading;
  }

  close() {
    if (this.isLoading) return;
    this.dialogRef.close();
  }

  openFileInput() {
    if (document.getElementById('cashReceiptsInput'))
      document.getElementById('cashReceiptsInput').click();
  }

  onFileSelected($event) {
    if (!$event || !$event.target || !$event.target.files || !$event.target.files[0]) return;
    const file: File = $event.target.files[0];
    if (!file.name || !file.name.toLowerCase().endsWith('.xlsx')) {
      this.snackBarService.openSnackBar(
        'El archivo debe ser de Excel con extensión .xlsx', undefined, 'alert'
      );
      return;
    }
    this.form.get('file').setValue(file);
  }

  onSubmit() {
    if (this.form.invalid) {
      this.snackBarService.openSnackBar(
        'Adjunta el archivo de Excel con los recibos de caja', undefined, 'alert'
      );
      return;
    }
    this.spinner.show();
    this.setLoading(true);
    this.accialService.syncCashReceiptsXlsx(this.form.get('file').value)
      .pipe(takeUntil(this._destroy$))
      .subscribe(
        (success: AccialVoucherSyncResponse) => {
          this.spinner.hide();
          this.setLoading(false);
          this.snackBarService.openSnackBar(
            success && success.message ? success.message : 'Los recibos de caja se cargaron correctamente',
            undefined, 'success', 8000
          );
          this.dialogRef.close({ state: true });
        },
        (error) => {
          this.spinner.hide();
          this.setLoading(false);
          this.snackBarService.openSnackBar(
            error && error.error && error.error.message ? error.error.message : ServiceMessages.GENERAL_HTTP_ERROR,
            undefined, 'error', 8000
          );
        }
      );
  }
}
